(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-blog-post"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    gsap.from(".blog-post-featured-image-container", {
      opacity: 0,
      y: 50,
      duration: 1.5,
      ease: "power3.out"
    });

    gsap.from(".blog-post-image-overlay-text h1", {
      opacity: 0,
      y: 20,
      duration: 1,
      delay: 0.5,
      ease: "power2.out"
    });

    // Animation for the main blog content
    gsap.from(".blog-post-content > *", {
      opacity: 0,
      y: 30,
      stagger: 0.2, // Staggers the animation for each child element
      duration: 0.8,
      delay: 1.2, // Starts after the image and title animation
      ease: "power2.out"
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  /* Keep your original hash scroll */
  (function () {
    const url = new URL(window.location.href);
    if (url.hash) {
      const card = document.getElementById(url.hash.slice(1));
      if (card) card.scrollIntoView({ behavior: 'instant' });
    }
  })();

  const openBtn    = document.querySelector('.filters-open-btn');
  const modalHost  = document.getElementById('filters-popup-host');
  const fallbackEl = document.getElementById('filters-fallback-wrapper');
  const applyBtn   = document.getElementById('filters-apply-btn');

  // NEW: Use a MutationObserver to detect when the product grid is updated.
  // This is more reliable than listening for clicks on individual filters.
  const productGridContainer = document.querySelector('.product-grid-container');
  if (productGridContainer) {
    const observer = new MutationObserver((mutationsList) => {
      // We check for mutations to see if the content is reloading.
      // If it is, and the modal is open, we close it.
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          if (window.location.hash === '#FiltersPopup') {
            window.location.hash = '';
            // We can stop observing once we've closed it, to be safe.
            // observer.disconnect();
          }
        }
      }
    });

    // Start observing the target node for configured mutations.
    observer.observe(productGridContainer, { childList: true, subtree: true });
  }


  function hideSortInside(node) {
    if (!node) return;
    node.querySelectorAll('select[name="sort_by"], [name="sort_by"]').forEach((el) => {
      const holder = el.closest('*');
      if (holder) holder.style.display = 'none';
    });
  }

  function findInlineFacetRow() {
    const obvious = document.querySelector(
      '.facets-horizontal, .facets__form--horizontal, .facets__form--disclosure, .facets__wrapper--horizontal, .filters-toolbar'
    );
    if (obvious) return obvious;
    const candidates = Array.from(document.querySelectorAll(
      '.facets, .facets__form, .facets__wrapper, .collection-filters, .collection__filters, .collection--filters, .filters-row'
    ));
    for (const node of candidates) {
      if (node.querySelectorAll('details, .facets__disclosure, .facet-group, .facets__group').length >= 3) return node;
    }
    const allBlocks = Array.from(document.querySelectorAll('section, div, form'));
    for (const node of allBlocks) {
      const txt = node.textContent?.toLowerCase() || '';
      if (
        (txt.includes('availability') || txt.includes('stock')) &&
        (txt.includes('price')) &&
        (txt.includes('category') || txt.includes('type')) &&
        (txt.includes('brand') || txt.includes('vendor'))
      ) {
        return node;
      }
    }
    return null;
  }

  function injectFacetsIntoModal() {
    if (!modalHost || modalHost.children.length) return;

    const inlineRow = findInlineFacetRow();
    if (inlineRow) {
      const clone = inlineRow.cloneNode(true);
      hideSortInside(clone);
      clone.querySelectorAll('form').forEach(f => {
        if (!f.getAttribute('action')) f.setAttribute('action', window.location.pathname);
      });
      modalHost.appendChild(clone);
      if (fallbackEl) fallbackEl.style.display = 'none';
      return;
    }

    if (fallbackEl) {
      fallbackEl.style.display = '';
      hideSortInside(fallbackEl);
    }
  }

  openBtn?.addEventListener('click', () => {
    setTimeout(injectFacetsIntoModal, 0);
  });

  window.addEventListener('hashchange', () => {
    if (location.hash === '#FiltersPopup') {
      injectFacetsIntoModal();
    }
  });

  // Apply button will submit the form and the MutationObserver will handle closing the modal.
  applyBtn?.addEventListener('click', (e) => {
    e.preventDefault();
    const popup = document.getElementById('FiltersPopup');
    const form = popup?.querySelector('form');
    if (form) {
      const submit = form.querySelector('[type="submit"]');
      if (submit) submit.click(); else form.submit();
    } else {
      // If no form (e.g., link-based filters), just close the modal.
      window.location.hash = '';
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
